import React from 'react'
import PropTypes from 'prop-types'
import { Form } from 'react-bootstrap'

import styles from './style.module.scss'

const CustomInput = React.forwardRef(({ className, name, placeholder, register = {}, validation, ...rest }, ref) => (
  <Form.Control
    className={`${className || ''} ${styles.formControl}`}
    ref={ref}
    placeholder={placeholder}
    {...register}
    {...rest}
  />
))

CustomInput.displayName = 'CustomInput'
CustomInput.propTypes = {
  name: PropTypes.string,
  className: PropTypes.any,
  register: PropTypes.any,
  validation: PropTypes.object,
  placeholder: PropTypes.string
}

export default CustomInput
